interface SelectorItem {
  id: string;
  name: string;
  slug: string;
  recommendationCount: number;
}

interface SelectorProps {
  selectedId: string | null;
  onChange: (id: string | null) => void;
  items: SelectorItem[];
  loading?: boolean;
  emptyLabel: string;
  placeholder: string;
  disabled?: boolean;
}

export function ReferenceSelector({
  selectedId,
  onChange,
  items,
  loading = false,
  emptyLabel,
  placeholder,
  disabled = false,
}: SelectorProps) {
  return (
    <select
      aria-label={placeholder}
      className="input py-2 text-sm"
      value={selectedId ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={loading || disabled}
    >
      <option value="">{emptyLabel}</option>
      {loading
        ? Array.from({ length: 5 }).map((_, i) => (
            <option key={i} disabled>
              Cargando...
            </option>
          ))
        : items.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
              {item.recommendationCount > 0 ? ` (${item.recommendationCount})` : ''}
            </option>
          ))}
    </select>
  )
}

export function CategorySelector({
  selectedId,
  onChange,
  categories,
  loading = false,
  disabled = false,
}: Omit<SelectorProps, 'items' | 'emptyLabel' | 'placeholder'> & { categories: SelectorItem[] }) {
  return (
    <ReferenceSelector
      selectedId={selectedId}
      onChange={onChange}
      items={categories}
      loading={loading}
      emptyLabel="Seleccionar categoría"
      placeholder="Categoría"
      disabled={disabled}
    />
  )
}

export function CitySelector({
  selectedId,
  onChange,
  cities,
  loading = false,
  disabled = false,
}: Omit<SelectorProps, 'items' | 'emptyLabel' | 'placeholder'> & { cities: SelectorItem[] }) {
  return (
    <ReferenceSelector
      selectedId={selectedId}
      onChange={onChange}
      items={cities}
      loading={loading}
      emptyLabel="Seleccionar ciudad"
      placeholder="Ciudad"
      disabled={disabled}
    />
  )
}